import * as sip from './sip';
export * as sip from './sip';

import * as common from './common';
export * as common from './common';

import * as epc from './epc';
export * as epc from './epc';

import * as tis from './tis';
export * as tis from './tis';

export default {
  common,
  sip,
  epc,
  tis
};
